import {
  Dashboard,
  Delete,
  DirectionsCar,
  ExitToApp,
  People,
  PublishedWithChanges,
  RateReview,
} from "@mui/icons-material";
import { NavItem } from "../../../types/navTypes";

export const navItems: NavItem[] = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: <Dashboard />,
  },
  {
    path: "/veiculos",
    title: "Veículos",
    icon: <DirectionsCar />,
  },
  {
    path: "/cliente",
    title: "Clientes",
    icon: <People />,
  },
  {
    title: "Assinatura",
    icon: <RateReview />,
    isModal: true,
  },
  {
    path: "/transferenciaVeiculos",
    title: "Transferência",
    icon: <PublishedWithChanges />,
  },
  {
    path: "/excluirVeiculo",
    title: "Excluir Veículo",
    icon: <Delete />,
    adminOnly: true,
  },
  {
    title: "Sair",
    icon: <ExitToApp />,
    isLogout: true,
  },
];
